import { Params } from '@angular/router';
import { FilterType } from '@features/product-filter/product-filter.config';
import { RelewiseRetailMediaParams } from '@core/services/relewise/relewise-tracking.model';

export const buildSearchParams = (
    params: Params,
    filterType?: FilterType,
    retailMediaParams?: RelewiseRetailMediaParams
): Params => {
    if (filterType === FilterType.CategoryResult) {
        return {
            ...params
        };
    }

    if (filterType === FilterType.SearchResult) {
        return {
            ...params,
            ...(retailMediaParams || {})
        };
    }

    return params;
};
